import { render } from "./Air.vue?vue&type=template&id=62ae6f8b"
import script from "./Air.vue?vue&type=script&lang=js"
export * from "./Air.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__